import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AddRoleComposer } from "@/forms/rema/addRole/composer"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { ShieldCheck } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

function AddRolePage() {
  const navigate = useNavigate()
  const { toast } = useToast()

  return (
    <div className="p-6 space-y-4">
      <Card className="shadow-sm pb-0">
        <CardHeader className="border-b bg-slate-700 text-white [&_p]:text-slate-300">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
              <ShieldCheck className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-xl">Add Role</CardTitle>
              <CardDescription className="text-base">Define a new RBAC role for users or workloads</CardDescription>
            </div>
          </div>
        </CardHeader>
      </Card>
      <Card className="shadow-sm">
        <CardContent className="p-6">
          <AddRoleComposer
            showHeader={false}
            onSuccess={() => navigate({ to: '/rema/roles' })}
            onError={(error) => toast({ title: 'Error', description: `Failed to create role: ${error.message}`, type: 'error' })}
            onCancel={() => navigate({ to: '/rema/roles' })}
          />
        </CardContent>
      </Card>
    </div>
  )
}

export const Route = createFileRoute("/rema/roles/add")({
  staticData: {
    title: 'Add Role',
    isSecured: true,
  },
  component: AddRolePage,
})
